<template>
  <div id="_2022_5">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h"
          >The 3rd international workshop on geographic modeling and simulation
          was successfully held
        </strong>
      </h3>
      <hr />
      <p>
        The 3rd International Workshop on Geographic Modeling and Simulation was
        successfully held at Nanjing Normal University (Suiyuan Campus) from
        October 26th to October 27th, 2024. With the theme “Modeling and
        Simulation for a Sustainable World”, the workshop focuses on theories,
        approaches, technologies and solutions of geographic modeling and
        simulation, and hopes to promote the exploration of sustainable
        development. The workshop was co-organized by the Modeling Geographical
        Systems Commission of IGU.
      </p>
      <p>
        This workshop invited Prof. Changchun Huang (Dean of School of
        Geography, Nanjing Normal University). Prof. Linwang Yuan (Vice
        principal of Nanjing Normal University), Prof. Michael Meadows (Past
        president of the IGU) and Prof. Val Snow (President of the IEMSs) to
        give the welcome speeches. The Chair and the Several Honorary Advisory
        Members of MGSC were invited to give the keynote speeches, including
        Prof. Min Chen, Prof. Stewart Fotheringham, Prof. Josef Strobl, Prof.
        Anthony Jakeman, Prof. Mei-Po Kwan, and Prof. Jinfeng Wang.
      </p>
      <div class="pic">
        <img
          style="width: 70%"
          src="../../../assets/static/img/Events/3rdIGU1.png"
        />
      </div>
      <p>
        The workshop featured 97 presentations held across 13 parallel sessions,
        including “Theories, Methodologies, and Applications of Earth System
        Models”, “Big Data Analytics, Modeling, Simulation, and AI in Health
        Geography”, and “Intelligent Simulation of Spatiotemporal Processes”. It
        attracted over 160 experts and scholars from 48 organizations across 11
        countries and regions, facilitating in-depth exchanges among
        international experts and strengthening collaboration and friendships
        among participants.
      </p>
      <div class="pic">
        <img
          style="width: 70%"
          src="../../../assets/static/img/Events/3rdIGU2.png"
        />
      </div>
      <p>
        During this workshop, the award ceremony for 2022-2024 IGU Outstanding
        Achievement Award in Geographical Information Modeling (OAA) and the
        Young Scholar Award (YSA) was held. At the closing ceremony of this
        workshop, the IGU Modeling Geographical Systems Commission Best Paper
        Awards were also presented to the winners.
      </p>
      <div class="pic">
        <img
          style="width: 35%"
          src="../../../assets/static/img/Events/3rdIGU3.png"
        />
        <img
          style="width: 35%; margin-left: 2.5%"
          src="../../../assets/static/img/Events/3rdIGU4.png"
        />
      </div>
      <div class="pic">
        <img
          style="width: 35%"
          src="../../../assets/static/img/Events/3rdIGU5.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2024_1'
};
</script>
<style scoped lang="less">
#_2022_5 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}

.pic {
  // display: table-cell;
  text-align: center;
  //height: 128px;
  //width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  // justify-content: center;
}
</style>
